import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "p-4" }
const _hoisted_2 = { style: {"font-size":"12px"} }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("label", { class: "pb-1 fw-bold fs-6" }, "Conflicting Client")
], -1 /* HOISTED */)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("text", { style: {"text-align":"left","font-size":"12px"} }, "There is an existing client that has the same name and date of birth as the referral you are trying to create.")
], -1 /* HOISTED */)
const _hoisted_5 = { class: "row" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "col-12 col-lg-6" }, [
  /*#__PURE__*/_createElementVNode("text", null, "Name:")
], -1 /* HOISTED */)
const _hoisted_7 = { class: "col-12 col-lg-6" }
const _hoisted_8 = { class: "text-capitalize" }
const _hoisted_9 = { class: "row" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "col-12 col-lg-6" }, [
  /*#__PURE__*/_createElementVNode("text", null, "MRN:")
], -1 /* HOISTED */)
const _hoisted_11 = { class: "col-12 col-lg-6" }
const _hoisted_12 = { class: "row" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "col-12 col-lg-6" }, [
  /*#__PURE__*/_createElementVNode("text", null, "Date of Birth:")
], -1 /* HOISTED */)
const _hoisted_14 = { class: "col-12 col-lg-6" }
const _hoisted_15 = { class: "row" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "col-12 col-lg-6" }, [
  /*#__PURE__*/_createElementVNode("text", null, "Status:")
], -1 /* HOISTED */)
const _hoisted_17 = { class: "col-12 col-lg-6" }
const _hoisted_18 = { class: "text-capitalize" }
const _hoisted_19 = { class: "row" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "col-12 col-lg-6" }, [
  /*#__PURE__*/_createElementVNode("text", null, "Branch:")
], -1 /* HOISTED */)
const _hoisted_21 = { class: "col-12 col-lg-6" }
const _hoisted_22 = { class: "mt-1 d-flex" }
const _hoisted_23 = ["checked"]
const _hoisted_24 = /*#__PURE__*/_createElementVNode("span", { class: "ms-1" }, "Ignore this conflict and create anyway", -1 /* HOISTED */)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("hr", null, null, -1 /* HOISTED */)
const _hoisted_26 = { class: "d-flex justify-content-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.options.DisplayName.toLowerCase()), 1 /* TEXT */)
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _hoisted_10,
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("span", null, _toDisplayString(_ctx.options.PatientIdNumber), 1 /* TEXT */)
        ])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _hoisted_13,
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("span", null, _toDisplayString(_ctx.formatDate(_ctx.options.DOB)), 1 /* TEXT */)
        ])
      ]),
      _createElementVNode("div", _hoisted_15, [
        _hoisted_16,
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.PatientStatuses.getKeyUsingValue(_ctx.options.Status).toLowerCase()), 1 /* TEXT */)
        ])
      ]),
      _createElementVNode("div", _hoisted_19, [
        _hoisted_20,
        _createElementVNode("div", _hoisted_21, [
          _createElementVNode("span", null, _toDisplayString(_ctx.options.LocationName), 1 /* TEXT */)
        ])
      ]),
      _createElementVNode("div", _hoisted_22, [
        _createElementVNode("input", {
          type: "checkbox",
          id: "ignoreConflict",
          checked: _ctx.options.isChecked
        }, null, 8 /* PROPS */, _hoisted_23),
        _hoisted_24
      ])
    ]),
    _hoisted_25,
    _createElementVNode("div", _hoisted_26, [
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-light border border-secondary me-1",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.ok()))
      }, "Continue"),
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-primary border border-primary",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.closeDialog()))
      }, "Cancel")
    ])
  ]))
}